import UniqAnswer from './UniqAnswer';

export default UniqAnswer;
